document.addEventListener("DOMContentLoaded", function () {
    const mainProductData = JSON.parse(document.querySelector("[data-product-obj]").innerHTML);
    console.log(123)

    // Dom selector
    let errorPicker = document.querySelector('.notification__error-picker');
    const mainContainer = document.querySelector(".list_variants-quantity");
    const buttonAddToCart = document.querySelector(".product__block-button_price .product__submit__add");
    const quickAddButton = document.querySelector(".gel-quick-add");
    const buttonAddToWrapper = document.querySelector(".product__block-button_price form");
    const idProduct = document.querySelector(".recharge-content").getAttribute("data-id-product");
    const freeInput = document.querySelectorAll(".free-input");
    const inputFullPrice = document.querySelector("input[data-full-price]");
    const variantsItem = document.querySelectorAll("variant-item");
    const variantsValue = document.querySelectorAll("variant-item [data-quantity]");
    const variantsId = document.querySelectorAll("variant-item [data-variant-id]");
    const variantsNewId = document.querySelectorAll("variant-item [data-ver-id]");
    const variantsNewIdSubsription = document.querySelectorAll("variant-item [data-ver-id-sub]");
    const subBtnForm = document.querySelector(".product__block-button_price button.btn--submit");
    const variantsInput = document.querySelectorAll(".varian__quantity-item input");
    const variantsLabel = document.querySelectorAll(".varian__quantity-item");
    const textMain = document.querySelector(".list_variants-title .small-badge");
    const textStatic = document.querySelector(".list_variants-title .small-badge__static");
    const textInfo = document.querySelector(".list_variants-title .small-badge")?.children;
    const discountApp = document.querySelector(".selling_plan-price .radio__price").getAttribute("data-discount-value");
    //get quantity of selected variant on load
    let initialVariantQuantity = document.querySelector('.varian__quantity-item input:checked');
    let initialVariantQuantityValue = initialVariantQuantity.value;

    // Event listener for changes in variant quantities
    variantsInput.forEach(el => {
        el.addEventListener("change", (e) => {
            const { target } = e;
            const { value } = target;

            changeMaxElement(value);

            //check which variant is selected and reset all variants if the selected variant is greater than the previous one
            if (initialVariantQuantityValue < value){
                resetAllVariants(value, false);
            } else {
                resetAllVariants(value, true);
            }

            //update variant select value for understanding which variant is selected (need for check variant logic)
            initialVariantQuantityValue = value;
            changeTextInfo();
            changeVariant(checkIsSubcribe() ? "data-cart-quantity-sub" : "data-cart-quantity");
            changePrice();
        })
    });

    // Function to change the maximum selected quantity
    function changeMaxElement(value) {
        if (!value) return;
        inputFullPrice.setAttribute("data-max-selected", value);
    }
    // Function to change the information text based on selected quantity
    function changeTextInfo() {
        if (textInfo.length !== 2) return;
        const maxValue = howAvalibleTaste();

        let textInfoSelected = textMain.getAttribute("data-selected");
        if (textInfoSelected !== '0'){
            textInfo[0].innerHTML = (maxValue - textInfoSelected) + (maxValue - textInfoSelected === 1 ? " taste" : " tastes");
            textInfo[1].innerHTML = maxValue + (maxValue === 1 ? " jar" : " jars");
            textStatic.classList.add("active");
        } else {
            textInfo[0].innerHTML = maxValue + (maxValue === 1 ? " taste" : " tastes");
            textInfo[1].innerHTML = maxValue + (maxValue === 1 ? " jar" : " jars");
            if(textStatic.classList.contains('active')){
                textStatic.classList.remove('active');
            }
        }
    }

    document.addEventListener('change::value', function(e) {
        changeTextInfo();
    });


    // Function to determine the available taste quantity
    function howAvalibleTaste() {
        return Number(inputFullPrice.getAttribute("data-max-selected"));
    }
    // Function to reset all variants based on the selected quantity
    function resetAllVariants(value, resetAll) {
        variantsItem.forEach((el, index) => {
            // check is all variants need to be reset
            if(resetAll){
                el?.setQuantity(0);
                el?.toggleQuantityField(0);
                el.addEventListener("click", el.showSelectorAndSetFitstValue);
                el.classList.remove("active-card");
                el.classList.remove("_not-active-item");
                textMain.setAttribute("data-selected", "0");
            } else {
                el.classList.remove("_not-active-item");
            }

            if (index == 0 && inputFullPrice.getAttribute("data-select-variant") == "true") {
                const { variants } = (JSON.parse(el.querySelector("[data-json-product]").innerHTML));
                setPriceVariant(variants[0], 1);
                changePrice()
            }
        });

        inputFullPrice.setAttribute("data-max-selected", value);
        inputFullPrice.setAttribute("data-general-quantity", 0);
        inputFullPrice.setAttribute("data-select-variant", false);
        inputFullPrice.value = inputFullPrice.getAttribute("data-value");
        textMain?.classList.toggle("_hide-text", false);

    }

    // Function to disable other elements based on the selected quantity
    function disabledOtherElement(maxValue, currentValue) {
        const isDisabled = Number(maxValue) === Number(currentValue);

        textMain?.classList.toggle("_hide-text", isDisabled);

        variantsItem.forEach((el) => {
            if (!el.classList.contains("active-card")) {
                if (isDisabled) {
                    el.classList.add("_not-active-item");
                } else {
                    el.classList.remove("_not-active-item");
                }
            }
        });

    }

    // Event listener for subscription form submit
    if (subBtnForm) {
        subBtnForm.addEventListener("click", function (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
            document.dispatchEvent(new CustomEvent('cart:change-variant', {
                bubbles: true, detail: {
                    form: document.querySelector(".product__form__wrapper form button.btn--submit")
                }
            }));
        })
    }

    // Function to fetch cart items
    const fetchCartItem = async () => {
        const res = await fetch("/cart.js");
        const cartItems = await res.json();
        return cartItems.items;
    };

    // Function to get cart items and update the free input quantity attribute
    const getCartItems = async () => {
        if (!freeInput) return;
        const mainId = idProduct;
        const items = await fetchCartItem();
        // const handleMain = "Main " + String(freeInput.dataset.handle).toLocaleLowerCase();
        const isCart = items.some(item => Number(item.variant_id) === Number(mainId));
        freeInput.forEach(input => {
            input.setAttribute("data-quantity", isCart ? 0 : 1);
        });
    };

    // Function to set quantity for variants based on cart items
    const setQuantityVariants = async () => {
        const items = await fetchCartItem();
        for (const item of items) {
            const { product_id, quantity, variant_id, selling_plan_allocation, key } = item;
            const inputSelector = document.querySelector(`[data-cart-el="${product_id}"]`);
            const inputSelectorSubscribe = document.querySelector(`[data-cart-el-sub="${product_id}"]`);

            if (inputSelector && !selling_plan_allocation) {
                updateInputValueAndAttributes(inputSelector, quantity, variant_id, key);
            }

            if (inputSelectorSubscribe && selling_plan_allocation) {
                updateInputValueAndAttributes(inputSelectorSubscribe, quantity, variant_id, key, selling_plan_allocation.selling_plan.id);
            }
        }
    };

    setQuantityVariants()

    // Function to update input value and attributes
    const updateInputValueAndAttributes = (inputSelector, quantity, variantId, key, sellingPlanId = null) => {
        const oldValue = Number(inputSelector.getAttribute('data-old-variant'));
        const currentValue = Number(inputSelector.getAttribute('data-old-variant'));

        inputSelector.value = quantity;
        inputSelector.setAttribute('data-change', oldValue === currentValue ? "false" : "true");
        inputSelector.setAttribute('data-old-variant', variantId);
        inputSelector.setAttribute('data-key-cart', key);

        if (sellingPlanId) {
            inputSelector.setAttribute('data-selling-plan-id', sellingPlanId);
        }
    };


    // Function to check if items have changed in the cart
    function checkChangeItem() {
        variantsId.forEach((el, index) => {
            const oneTimeInput = variantsNewId[index];
            const subsribeInput = variantsNewIdSubsription[index];

            const oldValueOneTime = oneTimeInput.getAttribute("data-old-variant");
            const newValueOneTime = oneTimeInput.getAttribute("data-new-variant");

            const oldValueSub = subsribeInput.getAttribute("data-old-variant");
            const newValueSub = subsribeInput.getAttribute("data-new-variant");
            if (oldValueOneTime != "") {
                oneTimeInput.setAttribute('data-change', "true");
            }
            if (oldValueSub != "") {
                subsribeInput.setAttribute('data-change', "true");
            }
        })
    }

    // Event listener for free cart items
    document.addEventListener('cart:free', getCartItems);

    // Event listener for changes in the full price input
    inputFullPrice.addEventListener("change", function () {
        const isSubcribe = checkIsSubcribe()
        setGenerallQuantity(isSubcribe ? "data-cart-quantity-sub" : "data-cart-quantity");
        // changeVariant(isSubcribe ? "data-cart-quantity-sub" : "data-cart-quantity");
        // changePrice();

        const maxValue = inputFullPrice.getAttribute("data-max-selected");
        const currentValue = inputFullPrice.getAttribute("data-general-quantity");
        disabledOtherElement(maxValue, currentValue);
        checkChangeItem();
        disabledAddToCart();

    })

    // Function to find the Recharge widget and set up event listeners
    const findWidget = setInterval(checkWidget, 10);
    function checkWidget() {
        if (document.querySelector(".rc-widget")) {
            clearInterval(findWidget)
            const subscriptionRadio = document.querySelector(".subscription-radio input");
            const onetimeRadio = document.querySelector(".onetime-radio input");
            const contentSubscription = document.querySelector(".recharge-product-widget__delivery-subscribe");
            const contentOnetime = document.querySelector(".recharge-product-widget__delivery-purchase");

            subscriptionRadio.addEventListener("change", function () {
                setGenerallQuantity("data-cart-quantity-sub");
                changeVariant("data-cart-quantity-sub");
                toggleContent(contentSubscription, contentOnetime, idProduct);
                changeBadgePrice(true)
                setTimeout(() => {
                    changePrice();
                }, 25);
            })
            onetimeRadio.addEventListener("change", function () {
                setGenerallQuantity("data-cart-quantity");
                changeVariant("data-cart-quantity");
                toggleContent(contentOnetime, contentSubscription, '');
                changeBadgePrice(false)
                setTimeout(() => {
                    changePrice();
                }, 25);
            })
            setGenerallQuantity("data-cart-quantity-sub");
            changeVariant("data-cart-quantity-sub");
            changePrice();

            changeBadgePrice(true)
        }
    }



    function changeBadgePrice(isSubscribe) {
        // Retrieve product variants from JSON
        const { variants } = JSON.parse(variantsItem[0].querySelector("[data-json-product]").innerHTML);

        // Selectors for badges
        const badgeSelectors = {
            fitstBadge: ".varian__quantity-item--1 .varian__quantity-badge",
            secondBadge: ".varian__quantity-item--2 .varian__quantity-badge",
            thirdBadge: ".varian__quantity-item--3 .varian__quantity-badge",
            fourthBadge: ".varian__quantity-item--4 .varian__quantity-badge",
        };

        // Function to get price data
        function getPriceData(variant, quantity, discount) {
            // Check if the variant has a price
            if (!variant.hasOwnProperty("price")) return null;

            // Calculate price and discount
            const discountValue = discount !== 0 ? discount / 100 : 0;
            const { price, compare_at_price } = variant;

            const priceWithoutDiscount = ((price / 100) * quantity).toFixed(2);
            const priceDiscount = ((price / 100) * quantity) - (((price / 100) * quantity) * discountValue).toFixed(2);


            const calculatePercentage = (price, compareAtPrice) => {
                if (!compareAtPrice || compareAtPrice === 0) {
                }
                return (100 - (((price * 100) / compareAtPrice) * 100)).toFixed(0);
            }
            const percentageWithoutDiscount = calculatePercentage(priceWithoutDiscount,compare_at_price);
            const percentageWithDiscount = calculatePercentage(priceDiscount,compare_at_price);


            // Return the price data
            return {
                price: ((compare_at_price / 100) - priceWithoutDiscount).toFixed(0),
                priceDiscount: ((compare_at_price / 100) - priceDiscount).toFixed(0),
                savePercentage: percentageWithoutDiscount,
                savePercentageDiscount: percentageWithDiscount
            };
        }

        // Iterate through input elements
        variantsInput.forEach(inputElement => {
            let currentVariantData = {
                variant: {},
                discount: Number(discountApp) || 0,
                quantity: "1",
                targetBadge: null,
                price: 0,
                isSubscribe: isSubscribe,
                changePrice: function () {
                    // Calculate and update price data
                    const priceData = getPriceData(this.variant, this.quantity, this.discount);
                    if (priceData) {
                        this.price = priceData.price;
                        this.priceDiscount = priceData.priceDiscount;

                        this.savePercentage = priceData.savePercentage;
                        this.savePercentageDiscount = priceData.savePercentageDiscount;
                    }
                    return this;
                },
            };

            // Set current variant data based on input value
            switch (inputElement.value) {
                case "2":
                    currentVariantData = {
                        ...currentVariantData,
                        variant: variants[1],
                        targetBadge: badgeSelectors.secondBadge,
                        quantity: inputElement.value,
                    };
                    break;
                case "3":
                    currentVariantData = {
                        ...currentVariantData,
                        variant: variants[2],
                        targetBadge: badgeSelectors.thirdBadge,
                        quantity: inputElement.value,
                    };
                    break;
                case "5":
                    currentVariantData = {
                        ...currentVariantData,
                        variant: variants[4],
                        targetBadge: badgeSelectors.fourthBadge,
                        quantity: inputElement.value,
                    };
                    break;
                default:
                    break;
            }

            // Check if the target badge and variant have price information
            if (currentVariantData.targetBadge && currentVariantData.variant.hasOwnProperty("price")) {
                // Calculate and update price, then check for null values before calling update function
                const filledObject = currentVariantData.changePrice();

                if (filledObject.price !== null || filledObject.priceDiscount !== null) {
                    const currentBadge = document.querySelector(filledObject.targetBadge);

                    if (currentBadge.hasAttribute("data-type") && currentBadge.getAttribute("data-type") === "percent" ) {
                        // changePriceHtml(filledObject.isSubscribe ? filledObject.savePercentageDiscount : filledObject.savePercentage, filledObject.targetBadge);
                    } else {
                        //  changePriceHtml(filledObject.isSubscribe ? filledObject.priceDiscount : filledObject.price, filledObject.targetBadge);
                    }
                }
            }
        });
    }

    // Function to change the selected variant price
    function changePrice() {
        let currentVariantPosition = Number(document.querySelector('[data-current-variant-position]:checked').getAttribute('data-current-variant-position'));
        let parentActiveVariant = mainProductData[currentVariantPosition - 1];
        let parentOriginalPrice = parentActiveVariant.price / 100;
        let parentComparePrice = parentActiveVariant.compare_at_price / 100;
        let discountLabel = document.querySelector('.rc-widget .discount-label');
        const enableSubscribe = inputFullPrice.dataset.subscribe === "true" ? true : false;

        const discountValue = enableSubscribe ? (Number(discountApp) / 100) : 0;
        const currentPrice = inputFullPrice.value;
        const currentPriceCompare = parentComparePrice;
        const priceNoDiscount = parentOriginalPrice;

        const priceWithDiscount = (priceNoDiscount - (priceNoDiscount * discountValue).toFixed(2)).toFixed(2);
        const comparePriceWithDiscount = (Number(currentPriceCompare).toFixed(2));
        const priceSave = (priceNoDiscount - priceWithDiscount).toFixed(2);

        const priceWidget = (priceNoDiscount - (priceNoDiscount * (Number(discountApp) / 100))).toFixed(2);
        const priceSaveWidget = (comparePriceWithDiscount - priceWidget).toFixed(2);

        const discountAmount = comparePriceWithDiscount - priceWithDiscount
        const discountPercent = (discountAmount / comparePriceWithDiscount * 100).toFixed(0)

        const currentServing = document.querySelector('.custom-style-gel--global-class input[name=\"varian-quantity\"]:checked');


        const buttonSellingPlan = document.querySelector(".subscription-radio");
        if (!buttonSellingPlan) return;
        const selectors = {
            widgetCompare: ".selling_plan-price_origin",
            widgetOrigin: ".radio__price .first-discount",
            widgetPriceWrapper: ".recharge-product-widget__delivery-subscribe .selling_plan",
            widgetPriceString: ".custom-style-gel--global-class .selling_plan-price",
            onlyRegular: ".only_price [data-product-price]",
            onlyCompare: ".only_price [data-compare-price]",
            badgeRegular: ".product__price-save [data-product-price]",
            badgeCompare: ".product__price-save [data-compare-price]",
            badgeSave: ".product__price-and-badge .product__price-save_badge",
            badgeSaveContainer: ".product__price-save_badge",
            compare: "#compare_price",
            regular: "#regular_price",
            discount: "#discount_price",
            save: "#save_price",
            quickAddButton: ".gel-quick-add",
            quickAddPrice: ".quick-gel__price",
            quickAddSalePrice: ".quick-gel__sale-price",
            rcDiscountLabel: ".rc-widget .discount-label"
        }
        if (enableSubscribe) {
            changePriceHtml(comparePriceWithDiscount, selectors.onlyCompare);
            changePriceHtml(priceWithDiscount, selectors.onlyRegular)

            changePriceHtml(comparePriceWithDiscount, selectors.widgetCompare);
            changePriceHtml(priceWithDiscount, selectors.widgetOrigin);

            changePriceHtml(comparePriceWithDiscount, selectors.badgeCompare);
            changePriceHtml(priceWithDiscount, selectors.badgeRegular);
            changePriceHtml(priceSave, selectors.badgeSave);
            hidePrice(comparePriceWithDiscount, priceWithDiscount, selectors.badgeSave);
            hidePrice(comparePriceWithDiscount, priceWithDiscount, selectors.badgeCompare);
            hidePrice(comparePriceWithDiscount, priceWithDiscount, selectors.onlyCompare);

            updateSalePriceBadge(selectors.widgetPriceString, discountPercent)
            updateServingInfo(selectors.widgetPriceWrapper, currentServing, priceWithDiscount)
            updateQuickAddPrice(selectors.quickAddPrice, comparePriceWithDiscount)
            updateQuickAddPrice(selectors.quickAddSalePrice, priceWithDiscount)
        } else {
            changePriceHtml(priceNoDiscount, selectors.onlyRegular)
            changePriceHtml(comparePriceWithDiscount, selectors.onlyCompare);

            changePriceHtml(priceNoDiscount, selectors.badgeRegular);
            changePriceHtml(comparePriceWithDiscount, selectors.compare);
            changePriceHtml(comparePriceWithDiscount, selectors.regular);
            changePriceHtml(priceWidget, selectors.discount);
            changePriceHtml(priceSaveWidget, selectors.save);

            hidePrice(priceNoDiscount, priceNoDiscount, selectors.badgeSave);
            hidePrice(priceNoDiscount, priceNoDiscount, selectors.badgeCompare);
            hidePrice(comparePriceWithDiscount, priceNoDiscount, selectors.onlyCompare);
            updateQuickAddPrice(selectors.quickAddPrice, '')
            updateQuickAddPrice(selectors.quickAddSalePrice, comparePriceWithDiscount)
        }
        if (discountLabel) {
            discountLabel.innerText = `Subscribe & save ${discountPercent}%`;
        }
        disabledAddToCart()
    }

    // Function to change the selected variant
    function changeVariant(nameAttr) {
        // const quantity = Number(inputFullPrice.getAttribute("data-general-quantity"));
        const quantity =  Number(inputFullPrice.getAttribute("data-max-selected"));
        const cartQuantity = Number(inputFullPrice.getAttribute(nameAttr));
        const generallQuantity = (quantity + cartQuantity) === 0 ? 1 : (quantity + cartQuantity);
        variantsItem.forEach((el, index) => {
            const { variants } = JSON.parse(el.querySelector("[data-json-product]").innerHTML);

            const variantsLength = [...variants].length

            let currentVariant;
            let currentVariantId;

            if (variants[quantity - 1]) {
                currentVariant = variants[quantity - 1];
            } else if (variantsLength < quantity) {
                currentVariant = variants.at(-1);
            } else {
                currentVariant = variants[0];
            }

            if (variants[generallQuantity - 1]) {
                currentVariantId = variants[generallQuantity - 1];
            } else if (variantsLength < generallQuantity) {
                currentVariantId = variants.at(-1);
            } else {
                currentVariantId = variants[0];
            }
            const { id } = currentVariantId;

            variantsId[index].value = id;
            variantsNewId[index].setAttribute("data-new-variant", id);
            variantsNewIdSubsription[index].setAttribute("data-new-variant", id);
            if (index === 0) {
                setPriceVariant(currentVariant, quantity)
            }
        })
    }

    // Function for checking subscription availability
    function checkIsSubcribe() {
        return inputFullPrice.getAttribute("data-subscribe") === "false" ? false : true;
    }

    // Function to set the price for a specific variant
    function setPriceVariant(json, koeff) {
        const koeffQuantity = koeff === 0 ? 1 : koeff
        // const koeffQuantity = 1
        const { price, compare_at_price } = json;
        const shopifyFormat = ((price * koeffQuantity / 100)).toFixed(2);
        inputFullPrice.value = shopifyFormat;
        inputFullPrice.setAttribute("data-price-compare",((compare_at_price * 1 / 100)).toFixed(2));
        return true
    }
    // Function to update the general quantity based on selected variants
    function setGenerallQuantity(nameAttr) {
        const generallQuantity = Number([...variantsValue].reduce((accum, elem) => accum + Number(elem.getAttribute("value")), 0));
        // const cartQuantity = Number(inputFullPrice.getAttribute(nameAttr));
        const cartQuantity = 0;
        inputFullPrice.setAttribute("data-general-quantity", generallQuantity + cartQuantity)
    }

    // Function to toggle the display of content based on conditions
    function toggleContent(showContent, hideContent, value) {
        showContent.style.display = "flex";
        hideContent.style.display = "none";
        if (freeInput) {
            freeInput.value = value;
        }
    }

    // Function to hide or show an element based on a price comparison
    function hidePrice(priceCompare, priceOrigin, element) {
        if (!document.querySelector(element)) return;
        const flag = Number(priceCompare) !== Number(priceOrigin);
        document.querySelector(element).classList.toggle("hidden", !flag);
    }

    // Function to dynamically change the content of an HTML element with a new digit
    function changePriceHtml(newDigit, element) {
        let container = document.querySelector(element);
        if (!container) return;
        let regex = /\d+(\.\d+)?/g;
        container.innerHTML = container.innerHTML.replace(regex, newDigit);
    }

    function updateServingInfo(element, currentServing, price){
        let quantity = currentServing.getAttribute("data-servings");
        let showBadge = currentServing.getAttribute("data-show");
        if (showBadge === "false") return;
        let target = document.querySelector(element);

        if(!target) return;
        if(target.querySelector(".serving_badge")){
            target.querySelector(".serving_badge").remove();
        }
        if(quantity === '0') return;
        target.appendChild(document.createElement("div")).classList.add("serving_badge");
        target.querySelector(".serving_badge").innerText = `$ ${(Number(price) / Number(quantity)).toFixed(1)} per servings`;
    }

    function updateQuickAddPrice(element, price){
        if(!document.querySelector(element)) return;
        price !== '' ? document.querySelector(element).innerText = `$${price}` : document.querySelector(element).innerText = '';
    }

    function updateSalePriceBadge(element, percent){
        let target = document.querySelector(element);
        if(!target) return;
        if(percent === '0' || percent == 'Infinity') return;
        if(target.querySelector(".save__percent")){
            target.querySelector(".save__percent").remove();
        }
        target.appendChild(document.createElement("div")).classList.add("save__percent");
        target.querySelector(".save__percent").innerHTML = `<span class="save__percent--value">${percent}% off today
      <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_3650_1018)">
      <path d="M14.685 9.33196C14.6579 9.12833 14.5217 8.96071 14.3301 8.89456L10.1175 7.44013L14.103 1.62501C14.2639 1.39005 14.2369 1.08069 14.0389 0.894082C13.8422 0.708549 13.5311 0.699745 13.3078 0.875719L11.463 2.3545L3.09405 8.94881C2.92868 9.07945 2.84277 9.28685 2.8701 9.48995C2.89723 9.69358 3.03336 9.8612 3.22497 9.92735L7.43767 11.3818L3.45209 17.1969C3.29119 17.4319 3.31819 17.7412 3.51625 17.9278C3.71427 18.1136 4.02339 18.1223 4.24737 17.9462L6.07853 16.5033L14.4611 9.87311C14.6264 9.74245 14.7123 9.53506 14.685 9.33196Z" fill="#FFE272"/>
      <path d="M15.0322 9.00732C15.0042 8.80579 14.8675 8.6394 14.676 8.5731L10.4644 7.11553L14.4149 1.38209C14.5743 1.15043 14.5459 0.84433 14.3474 0.658872C14.1501 0.474478 13.8396 0.464364 13.6175 0.637401L11.7832 2.09165L6.4761 16.0612L14.8113 9.5415C14.9757 9.41306 15.0605 9.20832 15.0322 9.00732Z" fill="#FFC945"/>
      </g>
      <defs>
      <filter id="filter0_i_3650_1018" x="2.86523" y="0.513672" width="12.1724" height="17.5596" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="1.54847"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"/>
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3650_1018"/>
      </filter>
      </defs>
      </svg>
        </span> `;
    }

    // Function to disable or enable the "Add to Cart" button based on conditions
    function disabledAddToCart() {
        if (!buttonAddToCart || !buttonAddToWrapper) return;
        const selectVariant = inputFullPrice.getAttribute("data-select-variant");
        const generalQuantity = Number(inputFullPrice.getAttribute("data-general-quantity"));
        const maxQuantity = Number(inputFullPrice.getAttribute("data-max-selected"));

        if (selectVariant === "false" || maxQuantity !== generalQuantity) {
            setTimeout(() => {
                buttonAddToCart.setAttribute("disabled", "true");
                if(quickAddButton){
                    quickAddButton.classList.add("disabled");
                }
                buttonAddToWrapper.addEventListener("click", scrollTo);
            }, 0);
        } else {
            buttonAddToCart.removeAttribute("disabled");
            if(quickAddButton){
                quickAddButton.classList.remove("disabled");
            }
            buttonAddToWrapper.removeEventListener("click", scrollTo);
        }
    }

    //check update count and set content for badge error picker
    function checkDataForErrorBadge(){
        let maxValue = howAvalibleTaste();
        let textInfoSelected = Number(textMain.getAttribute("data-selected"));
        if (errorPicker){
            let text = errorPicker.querySelector('span')
            let modifier = errorPicker.getAttribute('data-modifier')
            if (!text) return;
            if(modifier){
                maxValue - textInfoSelected === 1 ? text.innerText = `${modifier}` : text.innerText = `${modifier}s`
            } else {
                maxValue - textInfoSelected === 1 ? text.innerText = '' : ''
            }
        }
    }

    // Function to scroll to the main container and show the error badge and error state
    function scrollTo() {
        const y = mainContainer.getBoundingClientRect().top + window.pageYOffset - 150;
        textMain.classList.add("error-state");
        textStatic.classList.add("error-state");
        errorPicker ? errorPicker.classList.add("notification__error-picker--active") : null;
        checkDataForErrorBadge();
        setTimeout(() => {
            textMain.classList.remove("error-state");
            textStatic.classList.remove("error-state");
            errorPicker ? errorPicker.classList.remove("notification__error-picker--active") : null;
        }, 2500);
        window.scrollTo({ top: y, behavior: "smooth" });
    }



     //custom quick add button scroll to form if disabled
    const quickAddCustom = document.querySelector('.sticky_shop_atc');
    const form = document.querySelector('.product__form');

    // observer for element intersection with viewport
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                checkDataForErrorBadge();
                textMain.classList.add("error-state");
                textStatic.classList.add("error-state");
                errorPicker ? errorPicker.classList.add("notification__error-picker--active") : null;
                setTimeout(() => {
                    textMain.classList.remove("error-state");
                    textStatic.classList.remove("error-state");
                    errorPicker ? errorPicker.classList.remove("notification__error-picker--active") : null;
                }, 2500);
                observer.unobserve(form); // remove observer after scroll
            }
        });
    }, { threshold: 0.5 });

    if(quickAddCustom && form){
        quickAddCustom.addEventListener('click', function (event) {
            if (this.classList.contains('disabled')) {
                if (form) {
                    form.scrollIntoView({ behavior: "smooth", block: "center" });
                    observer.observe(form); // start observe form element
                }
            } else {
                form.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        });
    }
})


